import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    icon: "fa fa-clock",
    "text-color": "amber-10",
    title: "Click for more information"
  }, _ctx.$attrs, {
    rounded: "",
    onClick: _ctx.openModal
  }), null, 16, ["onClick"]))
}